require('/mnt/breedbase/ui/prod/js/webpack_util/adaptor.js');
/**
 * @fileoverview Entry point for modern Table component
 *
 * This entry bundles the new modular Table implementation and makes it
 * available globally via CXGN.Table for backward compatibility.
 *
 * The TableFactory automatically:
 * 1. Preserves legacy CXGN.Table as CXGN.TableLegacy (if it exists)
 * 2. Replaces CXGN.Table with the new implementation
 * 3. Maintains backward compatibility with existing code
 *
 * @module entries/table
 */

// Import TableFactory which auto-initializes the global CXGN.Table API
import { TableFactory, initGlobalAPI } from '../modules/table/TableFactory.js';

// Import Table class for direct ES6 usage
import { Table } from '../modules/table/Table.js';

// Import all supporting modules (for module resolution)
import '../modules/table/EventManager.js';
import '../modules/table/DataFetcher.js';
import '../modules/table/CacheManager.js';
import '../modules/table/ExportManager.js';
import '../modules/table/RendererFactory.js';
import '../modules/table/renderers/BaseRenderer.js';
import '../modules/table/renderers/DomTableRenderer.js';
import '../modules/table/renderers/DataTablesRenderer.js';
import '../modules/table/renderers/ServerSideRenderer.js';
import '../modules/table/renderers/VirtualScrollRenderer.js';

// Ensure global API is initialized (TableFactory.js does this automatically,
// but we can force it here for immediate availability)
if (typeof window !== 'undefined') {
  // Force initialization if not already done
  if (!window.CXGN || !window.CXGN.Table || window.CXGN.Table.version !== '2.0.0') {
    initGlobalAPI();
  }

  // Log initialization
  console.log('CXGN.Table: Modern implementation loaded and ready');
  console.log('CXGN.Table.version:', window.CXGN?.Table?.version);
}

// Export for ES6 module usage
export { Table, TableFactory };
